(function () {
  'use strict';

  var CFG = window.LAK_CONFIG;
  var C = { primary: CFG.primaryColor, primaryDark: CFG.primaryColorDark, cream: CFG.creamColor };

  // Handle prodotto Shopify verificati via SKU incrociato con il catalogo ufficiale
  // "Sistema Professionale 2026" (PDF), solo prodotti rivendita ACTIVE (esclusi formati/
  // prodotti solo cabina). Verificato 01/07/2026. Se un prodotto viene rinominato o
  // disattivato su Shopify, questo handle smette di funzionare e va aggiornato qui.
  var PRODUCT_HANDLES = {
    // --- VISO: Vata (pelle secca) ---
    v_detergente_vata: 'radiant-milk-latte-detergente-illuminante-al-mango',
    v_tonico_vata: 'equilibrium-tonic-1',
    v_siero_vata: 'essential-oil-siero-rafforzante-al-katafray',
    v_crema_vata: 'tone-lift-cream-crema-tonificante-lifting-allylang-ylang',
    v_maschera_vata: 'jelly-mask-maschera-defaticante-al-babassu',

    // --- VISO: Sensitive/Pitta (rossori lievi) ---
    v_detergente_sensitive: 'sensitive-milk',
    v_tonico_sensitive: 'sensitive-tonic',
    v_maschera_sensitive: 'sensitive-mask',
    v_crema_sensitive: 'sensitive-cream',
    v_nightbalm_sensitive: 'sensitive-night-balm',

    // --- VISO: Regenesis/Pitta (pelle iper-reattiva) ---
    v_detergente_regenesis: 'regenesis-h2o-bifascia-micellare-addolcente-allaloe',
    v_siero_regenesis: 'regenesis-serum-serum-calmante-alla-camomilla-blu',
    v_crema_regenesis: 'calming-cream-crema-lenitiva-antirossore-con-zanthalene',
    v_nightbalm_regenesis: 'regenesis-night-balm',

    // --- VISO: Kapha (pelle mista/grassa/impura) ---
    v_detergente_kapha: 'pure-gel',
    v_tonico_kapha: 'perfection-tonic',
    v_maschera_kapha: 'sebo-balance-mask',
    v_crema_kapha: 'sebo-balance-cream',
    v_crema_kapha_grassa: 'pure-light-cream',

    // --- VISO: Antiage/Chronology ---
    v_detergente_antiage: 'hydra-extreme-milk',
    v_tonico_antiage: 'equilibrium-tonic-1',
    v_siero_antiage: 'chronology-serum',
    v_crema_antiage: 'chronology-cream',
    v_crema_antiage_notte: 'densify-cream',
    v_maschera_antiage: 'renew-mask',
    v_contorno_occhi: 'midnight-butter',

    // --- CORPO: Udara (addome piatto / gonfiore) ---
    c_scrub_udara: 'itscrub-salino-ensalt-glow-scrub-frgommage-salin-roscrub-salin',
    c_olio_udara: 'itsinergia-garshan-tonic-engarshan-sinergy-tonic-frtonic-sinergy-rosinergia-tonica',
    c_finish_udara: 'olio-ossigenante-alle-spezie',

    // --- CORPO: Drenante gambe / Crio Gamathi (ritenzione, gambe pesanti) ---
    c_scrub_drenante: 'crio-mud-fango-drenante-effetto-freddo-alla-centella-asiatica',
    c_bendaggio_drenante: 'bendaggio-criocell',
    c_booster_drenante: 'booster-crio-on-the-go-concentrato-gambe-leggere-al-cipresso',
    c_crema_drenante: 'crio-legs-cream-crema-rinfrescante-alla-menta-piperita',

    // --- CORPO: Liposcultura / Garshan Slim (cellulite compatta, adiposità) ---
    c_scrub_liposcultura: 'scrub-esfoliante-e-stimolante-al-caffe-arabico',
    c_patch_liposcultura: 'cerotti-snellenti-alla-garcinia-cambogia',
    c_finish_liposcultura: 'olio-ossigenante-alle-spezie',
    c_crema_liposcultura: 'crema-rimodellante-alla-carnitina',

    // --- CORPO: Rassodante / Garshan Tonic (tono, post dimagrimento) ---
    c_scrub_rassodante: 'itscrub-salino-ensalt-glow-scrub-frgommage-salin-roscrub-salin',
    c_fango_rassodante: 'itfango-garshan-tonic-engarshan-tonic-mud-roargila-tonifianta',
    c_bendaggio_rassodante: 'bendaggio-lipolitico',
    c_crema_rassodante: 'itcrema-cell-tonic-encell-tonic-cream-frcreme-cell-tonic-rocrema-celulara-tonica'
  };

  var NEEDS = {
    idratazione: {
      label: 'Idratazione profonda',
      desc: 'Pelle secca, tirante, che chiede nutrimento',
      viso: {
        essenziale: [{ key: 'v_detergente_vata', role: 'Detergente' }, { key: 'v_crema_vata', role: 'Crema' }],
        completa: [
          { key: 'v_detergente_vata', role: 'Detergente' },
          { key: 'v_tonico_vata', role: 'Tonico' },
          { key: 'v_siero_vata', role: 'Siero' },
          { key: 'v_crema_vata', role: 'Crema' },
          { key: 'v_maschera_vata', role: 'Maschera' }
        ]
      },
      corpo: null,
      oils: [
        { name: 'Geranio Rosa', handle: 'itacqua-di-geranio-rosa-engeranium-rose-floral-water-roienupar', desc: 'Nutriente, armonizzante' },
        { name: 'Lavanda', handle: 'itacqua-di-lavanda-enlavender-floral-water-rolevantica', desc: 'Rilassante, riequilibrante' },
        { name: 'Camomilla Romana', handle: 'itcamomilla-romana-enroman-chamomile', desc: 'Calmante, distensivo' }
      ]
    },
    rossori: {
      label: 'Rossori e sensibilità',
      desc: 'Pelle reattiva, che si irrita facilmente',
      viso: {
        essenziale: [{ key: 'v_detergente_sensitive', role: 'Detergente' }, { key: 'v_crema_sensitive', role: 'Crema' }],
        completa: [
          { key: 'v_detergente_sensitive', role: 'Detergente' },
          { key: 'v_tonico_sensitive', role: 'Tonico' },
          { key: 'v_siero_regenesis', role: 'Siero' },
          { key: 'v_crema_sensitive', role: 'Crema giorno' },
          { key: 'v_nightbalm_sensitive', role: 'Balsamo notte' },
          { key: 'v_maschera_sensitive', role: 'Maschera' }
        ]
      },
      corpo: null,
      oils: [
        { name: 'Camomilla Blu', handle: 'itcamomilla-blu-enblue-chamomile', desc: 'Lenitivo, antirossore' },
        { name: 'Lavanda', handle: 'itacqua-di-lavanda-enlavender-floral-water-rolevantica', desc: 'Calmante, riequilibrante' },
        { name: 'Benzoino Assoluta', handle: 'itbenzoino-assoluta-enstyrax-benzoe', desc: 'Protettivo, avvolgente' }
      ]
    },
    purificazione: {
      label: 'Pelle grassa, impura o corpo gonfio',
      desc: 'Pori dilatati, ritenzione, cellulite, gambe pesanti',
      viso: {
        essenziale: [{ key: 'v_detergente_kapha', role: 'Detergente' }, { key: 'v_crema_kapha', role: 'Crema' }],
        completa: [
          { key: 'v_detergente_kapha', role: 'Detergente' },
          { key: 'v_tonico_kapha', role: 'Tonico' },
          { key: 'v_maschera_kapha', role: 'Maschera' },
          { key: 'v_crema_kapha', role: 'Crema' }
        ]
      },
      corpo: {
        essenziale: [{ key: 'c_scrub_drenante', role: 'Scrub' }, { key: 'c_crema_drenante', role: 'Crema gambe' }],
        completa: [
          { key: 'c_scrub_drenante', role: 'Scrub esfoliante' },
          { key: 'c_bendaggio_drenante', role: 'Bendaggio' },
          { key: 'c_booster_drenante', role: 'Booster gambe' },
          { key: 'c_crema_drenante', role: 'Crema gambe' },
          { key: 'c_scrub_liposcultura', role: 'Scrub corpo' },
          { key: 'c_finish_liposcultura', role: 'Booster lipolitico' },
          { key: 'c_crema_liposcultura', role: 'Crema rimodellante' }
        ]
      },
      oils: [
        { name: 'Ginepro', handle: 'itacqua-di-ginepro-enjuniper-floral-water-roienupar', desc: 'Purificante, detossinante' },
        { name: 'Bergamotto', handle: 'itbergamotto-enbergamot', desc: 'Riequilibrante, energizzante' },
        { name: 'Cajeput', handle: 'cajeput', desc: 'Purificante, rinfrescante' }
      ]
    },
    antietà: {
      label: 'Primi segni del tempo',
      desc: 'Perdita di tono, rughe, luminosità in calo',
      viso: {
        essenziale: [{ key: 'v_detergente_antiage', role: 'Detergente' }, { key: 'v_crema_antiage', role: 'Crema' }],
        completa: [
          { key: 'v_detergente_antiage', role: 'Detergente' },
          { key: 'v_tonico_antiage', role: 'Tonico' },
          { key: 'v_siero_antiage', role: 'Siero' },
          { key: 'v_crema_antiage', role: 'Crema giorno' },
          { key: 'v_crema_antiage_notte', role: 'Crema notte' },
          { key: 'v_maschera_antiage', role: 'Maschera' },
          { key: 'v_contorno_occhi', role: 'Contorno occhi' }
        ]
      },
      corpo: {
        essenziale: [{ key: 'c_scrub_rassodante', role: 'Scrub' }, { key: 'c_crema_rassodante', role: 'Crema rassodante' }],
        completa: [
          { key: 'c_scrub_rassodante', role: 'Scrub esfoliante' },
          { key: 'c_fango_rassodante', role: 'Fango tonificante' },
          { key: 'c_bendaggio_rassodante', role: 'Bendaggio' },
          { key: 'c_crema_rassodante', role: 'Crema rassodante' }
        ]
      },
      oils: [
        { name: 'Angelica Radice', handle: 'itangelica-radice-enangelica-radice-archangelica', desc: 'Rigenerante, corroborante' },
        { name: 'Arancio Extra', handle: 'itarancio-extra-enorange', desc: 'Rivitalizzante, energizzante' },
        { name: 'Benzoino Assoluta', handle: 'itbenzoino-assoluta-enstyrax-benzoe', desc: 'Nutriente, protettivo' }
      ]
    }
  };

  var state = { step: 0, age: 35, needKey: null, zone: null, intensity: null, oil: null, productCache: {} };

  function money(n) { return '\u20ac' + n.toFixed(2).replace('.', ','); }
  function ageLabel(a) {
    if (a < 28) return 'giovane';
    if (a < 42) return 'matura in equilibrio';
    return 'matura ed esigente';
  }

  // --- Storefront API ---
  function fetchProductByHandle(handle) {
    if (state.productCache[handle]) return Promise.resolve(state.productCache[handle]);

    var query = 'query($handle: String!) {' +
      ' product(handle: $handle) {' +
      '   title' +
      '   featuredImage { url }' +
      '   availableForSale' +
      '   priceRange { minVariantPrice { amount } }' +
      '   variants(first: 1) { edges { node { id availableForSale } } }' +
      ' } }';

    return fetch('https://' + CFG.shopDomain + '/api/' + CFG.apiVersion + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ query: query, variables: { handle: handle } })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.data || !data.data.product) {
          console.error('Lakshmi configuratore: prodotto non trovato per handle', handle);
          return null;
        }
        var p = data.data.product;
        var result = {
          title: p.title,
          image: p.featuredImage ? p.featuredImage.url : null,
          price: parseFloat(p.priceRange.minVariantPrice.amount),
          variantId: p.variants.edges.length ? p.variants.edges[0].node.id : null,
          available: p.availableForSale
        };
        state.productCache[handle] = result;
        return result;
      })
      .catch(function (err) {
        console.error('Lakshmi configuratore: errore Storefront API', err);
        return null;
      });
  }

  function resolveItem(item) {
    var handle = PRODUCT_HANDLES[item.key];
    return fetchProductByHandle(handle).then(function (p) {
      if (!p) return null;
      return { key: item.key, handle: handle, role: item.role || '', name: p.title, price: p.price, img: p.image, variantId: p.variantId, available: p.available };
    });
  }

  function resolveOil(oil) {
    return fetchProductByHandle(oil.handle).then(function (p) {
      if (!p) return null;
      return { role: 'Olio essenziale', name: p.title, desc: oil.desc, price: p.price, img: p.image, variantId: p.variantId, available: p.available, handle: oil.handle };
    });
  }

  // --- Cart AJAX API ---
  function addToCart(items) {
    var lineItems = items
      .filter(function (i) { return i.variantId; })
      .map(function (i) {
        var numericId = i.variantId.split('/').pop();
        return { id: numericId, quantity: 1 };
      });

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: lineItems })
    }).then(function (r) {
      if (!r.ok) throw new Error('Errore aggiunta al carrello');
      return r.json();
    });
  }

  // --- Helpers per combinare items in base a zona scelta ---
  function itemsForZone(need, zone, intensity) {
    var items = [];
    if ((zone === 'viso' || zone === 'entrambi') && need.viso) {
      items = items.concat(need.viso[intensity]);
    }
    if ((zone === 'corpo' || zone === 'entrambi') && need.corpo) {
      items = items.concat(need.corpo[intensity]);
    }
    return items;
  }

  function zoneAvailable(need, zone) {
    if (zone === 'viso') return !!need.viso;
    if (zone === 'corpo') return !!need.corpo;
    if (zone === 'entrambi') return !!need.viso && !!need.corpo;
    return false;
  }

  // --- UI ---

  function render() {
    var root = document.getElementById('lak-configurator-root');
    root.innerHTML = '';

    var totalSteps = 5;
    var progress = document.createElement('div');
    progress.style.cssText = 'display:flex; gap:6px; margin-bottom:1.5rem;';
    for (var i = 0; i < totalSteps; i++) {
      var bar = document.createElement('div');
      bar.style.cssText = 'flex:1; height:3px; border-radius:2px; background:' + (i <= state.step ? C.primary : '#e5e0d5') + '; transition: background .3s;';
      progress.appendChild(bar);
    }
    progress.id = 'lak-progress-bar';
    root.appendChild(progress);

    var main = document.createElement('div');
    main.id = 'lak-main';
    main.style.cssText = 'opacity:0; transform:translateY(8px); transition: opacity .4s ease, transform .4s ease;';
    root.appendChild(main);

    if (state.step === 0) renderAge(main);
    else if (state.step === 1) renderNeed(main);
    else if (state.step === 2) renderZone(main);
    else if (state.step === 3) renderIntensity(main);
    else if (state.step === 4) renderOil(main);

    requestAnimationFrame(function () {
      main.style.opacity = '1';
      main.style.transform = 'translateY(0)';
    });
  }

  function header(container, title, subtitle) {
    var h = document.createElement('div');
    h.style.cssText = 'margin-bottom:1.25rem;';
    h.innerHTML = '<h3 style="margin:0 0 4px; font-size:20px; font-weight:600;">' + title + '</h3><p style="margin:0; font-size:14px; color:#6b6b68;">' + subtitle + '</p>';
    container.appendChild(h);
  }

  function backButton(onClick) {
    var back = document.createElement('button');
    back.textContent = 'Indietro';
    back.style.cssText = 'width:100%; background:white; border:1px solid #e5e0d5; border-radius:8px; height:40px; cursor:pointer;';
    back.onclick = onClick;
    return back;
  }

  function renderAge(container) {
    header(container, 'Quanti anni hai?', 'Ci aiuta a calibrare intensità e attivi giusti per te');
    var wrap = document.createElement('div');
    wrap.style.cssText = 'padding:1.5rem 0 2rem;';
    var big = document.createElement('div');
    big.style.cssText = 'text-align:center; font-size:44px; font-weight:600; color:' + C.primary + '; margin-bottom:4px; letter-spacing:-0.02em;';
    big.textContent = state.age;
    var sub = document.createElement('div');
    sub.style.cssText = 'text-align:center; font-size:13px; color:#6b6b68; margin-bottom:1.75rem;';
    sub.textContent = 'anni · pelle ' + ageLabel(state.age);
    var slider = document.createElement('input');
    slider.type = 'range'; slider.min = 18; slider.max = 70; slider.value = state.age; slider.step = 1;
    var updateProgress = function () {
      var pct = ((state.age - 18) / (70 - 18)) * 100;
      slider.style.setProperty('--range-progress', pct + '%');
    };
    slider.oninput = function () {
      state.age = parseInt(this.value);
      big.textContent = state.age;
      sub.textContent = 'anni · pelle ' + ageLabel(state.age);
      updateProgress();
    };
    wrap.appendChild(big); wrap.appendChild(sub); wrap.appendChild(slider);
    container.appendChild(wrap);
    updateProgress();

    var next = document.createElement('button');
    next.textContent = 'Continua';
    next.style.cssText = 'width:100%; background:' + C.primary + '; color:white; border:none; border-radius:10px; height:48px; font-size:15px; font-weight:600; cursor:pointer; transition:opacity .15s;';
    next.onmouseenter = function () { this.style.opacity = '0.9'; };
    next.onmouseleave = function () { this.style.opacity = '1'; };
    next.onclick = function () { state.step = 1; render(); };
    container.appendChild(next);
  }

  function renderNeed(container) {
    header(container, 'Cosa vuoi migliorare?', 'La tua priorità principale in questo momento');
    var grid = document.createElement('div');
    grid.style.cssText = 'display:flex; flex-direction:column; gap:8px; margin-bottom:1.25rem;';
    Object.keys(NEEDS).forEach(function (key) {
      var n = NEEDS[key];
      var row = document.createElement('button');
      row.style.cssText = 'text-align:left; padding:16px 18px; border-radius:14px; cursor:pointer; border:1px solid #e5e0d5; background:white; box-shadow:0 1px 3px rgba(0,0,0,0.04); transition: all .18s ease;';
      row.onmouseenter = function () { this.style.borderColor = C.primary; this.style.boxShadow = '0 4px 12px rgba(56,81,80,0.12)'; this.style.transform = 'translateY(-1px)'; };
      row.onmouseleave = function () { this.style.borderColor = '#e5e0d5'; this.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)'; this.style.transform = 'translateY(0)'; };
      row.innerHTML = '<p style="margin:0 0 2px; font-size:14px; font-weight:600;">' + n.label + '</p><p style="margin:0; font-size:12px; color:#6b6b68;">' + n.desc + '</p>';
      row.onclick = function (k) { return function () { state.needKey = k; state.zone = null; state.step = 2; render(); }; }(key);
      grid.appendChild(row);
    });
    container.appendChild(grid);
    container.appendChild(backButton(function () { state.step = 0; render(); }));
  }

  function renderZone(container) {
    var need = NEEDS[state.needKey];
    header(container, 'Viso, corpo o entrambi?', 'Su cosa vuoi concentrare la tua routine');

    var options = [
      { key: 'viso', label: 'Solo viso', enabled: !!need.viso },
      { key: 'corpo', label: 'Solo corpo', enabled: !!need.corpo },
      { key: 'entrambi', label: 'Viso e corpo', enabled: !!need.viso && !!need.corpo }
    ];

    var grid = document.createElement('div');
    grid.style.cssText = 'display:flex; flex-direction:column; gap:8px; margin-bottom:1.25rem;';
    options.forEach(function (o) {
      if (!o.enabled) return;
      var row = document.createElement('button');
      row.style.cssText = 'text-align:left; padding:16px 18px; border-radius:14px; cursor:pointer; border:1px solid #e5e0d5; background:white; box-shadow:0 1px 3px rgba(0,0,0,0.04); transition: all .18s ease;';
      row.onmouseenter = function () { this.style.borderColor = C.primary; this.style.boxShadow = '0 4px 12px rgba(56,81,80,0.12)'; this.style.transform = 'translateY(-1px)'; };
      row.onmouseleave = function () { this.style.borderColor = '#e5e0d5'; this.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)'; this.style.transform = 'translateY(0)'; };
      row.innerHTML = '<p style="margin:0; font-size:14px; font-weight:600;">' + o.label + '</p>';
      row.onclick = function (opt) { return function () { state.zone = opt.key; state.step = 3; render(); }; }(o);
      grid.appendChild(row);
    });
    container.appendChild(grid);

    if (!need.corpo) {
      var note = document.createElement('p');
      note.style.cssText = 'font-size:12px; color:#9a9890; margin:-0.5rem 0 1rem;';
      note.textContent = 'Per questa esigenza abbiamo solo prodotti viso.';
      container.appendChild(note);
    }

    container.appendChild(backButton(function () { state.step = 1; render(); }));
  }

  function renderIntensity(container) {
    var need = NEEDS[state.needKey];
    header(container, 'Routine essenziale o completa?', 'Costruiamo il pacchetto giusto per il tempo che vuoi dedicarci');

    var loading = document.createElement('p');
    loading.textContent = 'Calcolo prezzi in corso...';
    loading.style.cssText = 'font-size:13px; color:#6b6b68;';
    container.appendChild(loading);

    var opts = [
      { key: 'essenziale', title: 'Essenziale', items: itemsForZone(need, state.zone, 'essenziale') },
      { key: 'completa', title: 'Completa', items: itemsForZone(need, state.zone, 'completa') }
    ];

    Promise.all(
      opts.map(function (o) {
        return Promise.all(o.items.map(resolveItem)).then(function (resolved) {
          o.total = resolved.reduce(function (s, i) { return s + (i ? i.price : 0); }, 0);
          return o;
        });
      })
    ).then(function (resolvedOpts) {
      loading.remove();
      var grid = document.createElement('div');
      grid.style.cssText = 'display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-bottom:1.25rem;';
      resolvedOpts.forEach(function (o) {
        var card = document.createElement('button');
        card.style.cssText = 'text-align:left; padding:20px 16px; border-radius:14px; cursor:pointer; border:1px solid #e5e0d5; background:white; box-shadow:0 1px 3px rgba(0,0,0,0.04); transition: all .18s ease;';
        card.onmouseenter = function () { this.style.borderColor = C.primary; this.style.boxShadow = '0 4px 12px rgba(56,81,80,0.12)'; this.style.transform = 'translateY(-2px)'; };
        card.onmouseleave = function () { this.style.borderColor = '#e5e0d5'; this.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)'; this.style.transform = 'translateY(0)'; };
        card.innerHTML =
          '<p style="margin:0 0 4px; font-size:15px; font-weight:600;">' + o.title + '</p>' +
          '<p style="margin:0 0 10px; font-size:12px; color:#6b6b68;">' + o.items.length + ' prodotti</p>' +
          '<p style="margin:0; font-size:13px; color:' + C.primary + '; font-weight:600;">da ' + money(o.total) + '</p>';
        card.onclick = function (opt) { return function () { state.intensity = opt.key; state.step = 4; render(); }; }(o);
        grid.appendChild(card);
      });
      container.appendChild(grid);
      container.appendChild(backButton(function () { state.step = 2; render(); }));
    });
  }

  function renderOil(container) {
    var need = NEEDS[state.needKey];
    header(container, 'Completa con un olio essenziale', 'Il tocco finale del tuo rituale, scegli quello più in sintonia con te');

    var grid = document.createElement('div');
    grid.style.cssText = 'display:flex; flex-direction:column; gap:8px; margin-bottom:1rem;';
    container.appendChild(grid);

    Promise.all(need.oils.map(resolveOil)).then(function (resolvedOils) {
      resolvedOils.forEach(function (oil) {
        if (!oil) return;
        var row = document.createElement('button');
        var selected = state.oil && state.oil.handle === oil.handle;
        row.style.cssText = 'display:flex; justify-content:space-between; align-items:center; text-align:left; padding:12px 14px; border-radius:10px; cursor:pointer; border:1px solid ' + (selected ? C.primary : '#e5e0d5') + '; background:' + (selected ? C.cream : 'white') + ';';
        row.innerHTML =
          '<div><p style="margin:0 0 2px; font-size:14px; font-weight:600;">' + oil.name + '</p>' +
          '<p style="margin:0; font-size:12px; color:#6b6b68;">' + oil.desc + '</p></div>' +
          '<span style="font-size:14px; font-weight:600;">' + money(oil.price) + '</span>';
        row.onclick = function (o) { return function () { state.oil = o; render(); }; }(oil);
        grid.appendChild(row);
      });

      var skip = document.createElement('button');
      skip.textContent = 'Salta questo passaggio';
      skip.style.cssText = 'width:100%; background:none; border:none; color:#6b6b68; font-size:13px; text-decoration:underline; margin-bottom:1rem; cursor:pointer;';
      skip.onclick = function () { state.oil = null; renderSummary(); };
      container.appendChild(skip);

      var btnRow = document.createElement('div');
      btnRow.style.cssText = 'display:flex; gap:8px;';
      var back = document.createElement('button');
      back.textContent = 'Indietro';
      back.style.cssText = 'flex:0 0 auto; padding:0 16px; background:white; border:1px solid #e5e0d5; border-radius:8px; height:44px; cursor:pointer;';
      back.onclick = function () { state.step = 3; render(); };
      var next = document.createElement('button');
      next.textContent = 'Componi il mio pacchetto';
      next.style.cssText = 'flex:1; background:' + C.primary + '; color:white; border:none; border-radius:8px; height:44px; font-size:15px; cursor:pointer;';
      next.onclick = function () { renderSummary(); };
      btnRow.appendChild(back);
      btnRow.appendChild(next);
      container.appendChild(btnRow);
    });
  }

  function renderSummary() {
    document.getElementById('lak-progress-bar').style.display = 'none';
    var main = document.getElementById('lak-main');
    main.innerHTML = '<p style="text-align:center; padding:3rem 0; font-size:14px; color:#6b6b68;">Componendo il tuo rituale su misura…</p>';

    var need = NEEDS[state.needKey];
    var itemDefs = itemsForZone(need, state.zone, state.intensity);

    Promise.all(itemDefs.map(resolveItem)).then(function (items) {
      items = items.filter(Boolean);
      if (state.oil) items = items.concat([state.oil]);

      var total = items.reduce(function (s, i) { return s + i.price; }, 0);
      var qualifiesFreeShipping = total >= CFG.freeShippingThreshold;
      var missing = CFG.freeShippingThreshold - total;

      main.innerHTML = '';
      main.style.opacity = '0'; main.style.transform = 'translateY(8px)';

      var zoneLabel = state.zone === 'entrambi' ? 'viso e corpo' : state.zone;
      var intro = document.createElement('div');
      intro.style.cssText = 'margin-bottom:1.25rem; padding:14px 16px; background:' + C.cream + '; border-radius:12px;';
      intro.innerHTML = '<p style="margin:0; font-size:13px; line-height:1.6; color:' + C.primaryDark + ';">A ' + state.age + ' anni, per <strong>' + need.label.toLowerCase() + '</strong> (' + zoneLabel + '), abbiamo composto un rituale ' + (state.intensity === 'completa' ? 'completo' : 'essenziale') + ' pensato per te.</p>';
      main.appendChild(intro);

      var list = document.createElement('div');
      list.style.cssText = 'display:flex; flex-direction:column; gap:10px; margin-bottom:1.25rem;';
      items.forEach(function (item) {
        var row = document.createElement('div');
        row.style.cssText = 'display:flex; align-items:center; gap:12px;';
        var imgHtml = item.img
          ? '<div style="width:44px; height:44px; border-radius:8px; background:' + C.cream + ' url(' + item.img + ') center/cover; flex-shrink:0;"></div>'
          : '<div style="width:44px; height:44px; border-radius:8px; background:' + C.cream + '; flex-shrink:0;"></div>';
        row.innerHTML = imgHtml +
          '<div style="flex:1;"><p style="margin:0; font-size:11px; text-transform:uppercase; letter-spacing:.03em; color:#9a9890;">' + item.role + '</p>' +
          '<p style="margin:0; font-size:14px; font-weight:600;">' + item.name + '</p></div>' +
          '<p style="margin:0; font-size:14px; font-weight:600;">' + money(item.price) + '</p>';
        list.appendChild(row);
      });
      main.appendChild(list);

      var totals = document.createElement('div');
      totals.style.cssText = 'padding-top:10px; border-top:1px solid #e5e0d5;';
      var shippingLine = qualifiesFreeShipping
        ? '<div style="display:flex; justify-content:space-between; font-size:13px; color:' + C.primary + '; margin-bottom:8px;"><span>Spedizione</span><span>Gratuita</span></div>'
        : '<div style="font-size:12px; color:#6b6b68; margin-bottom:8px;">Aggiungi ' + money(missing) + ' per la spedizione gratuita</div>';
      totals.innerHTML =
        '<div style="display:flex; justify-content:space-between; font-size:19px; font-weight:600;"><span>Totale rituale</span><span>' + money(total) + '</span></div>' +
        shippingLine;
      main.appendChild(totals);

      var cta = document.createElement('button');
      cta.textContent = 'Aggiungi il rituale al carrello';
      cta.style.cssText = 'width:100%; margin-top:1rem; background:' + C.primary + '; color:white; border:none; border-radius:8px; height:46px; font-size:15px; cursor:pointer;';
      cta.onclick = function () {
        cta.disabled = true;
        cta.textContent = 'Aggiunta in corso...';
        addToCart(items)
          .then(function () {
            cta.textContent = 'Aggiunto al carrello ✓';
            setTimeout(function () { window.location.href = '/cart'; }, 700);
          })
          .catch(function () {
            cta.disabled = false;
            cta.textContent = 'Errore, riprova';
          });
      };
      main.appendChild(cta);

      var restart = document.createElement('button');
      restart.textContent = 'Ricomincia';
      restart.style.cssText = 'width:100%; background:none; border:none; color:#6b6b68; font-size:13px; text-decoration:underline; margin-top:12px; cursor:pointer;';
      restart.onclick = function () {
        state = { step: 0, age: 35, needKey: null, zone: null, intensity: null, oil: null, productCache: state.productCache };
        document.getElementById('lak-progress-bar').style.display = 'flex';
        render();
      };
      main.appendChild(restart);

      requestAnimationFrame(function () {
        main.style.transition = 'opacity .4s ease, transform .4s ease';
        main.style.opacity = '1'; main.style.transform = 'translateY(0)';
      });
    });
  }

  render();
})();